export const common = {
  // Navigation
  nav_home: "Главная",
  nav_hospitals: "Больницы",
  nav_services: "Услуги",
  nav_posts: "Публикации",
  nav_about: "О нас",
  nav_contact: "Контакты",
  
  // Auth
  login: "Войти",
  signup: "Регистрация",
  logout: "Выйти",
  welcome_user: "Добро пожаловать",
  email: "Электронная почта",
  password: "Пароль",
  confirm_password: "Подтвердите пароль",
  full_name: "Полное имя",
  phone: "Номер телефона",
  forgot_password: "Забыли пароль?",
  
  // Hero Section
  hero_title: "Современные и передовые медицинские услуги в Южной Корее",
  hero_subtitle: "MediVoyage связывает международных пациентов с надёжными больницами и опытными врачами в Южной Корее",
  hero_description: "Мы оказываем комплексную помощь пациентам, приезжающим в Корею на лечение: организуем онлайн-консультации с врачами, записываем к подходящим специалистам в проверенные клиники, обеспечиваем услуги профессионального переводчика, а также организуем поездки по туристическим достопримечательностям Кореи.",
  hero_cta_primary: "Бесплатная консультация",
  hero_cta_secondary: "Посмотреть услуги",
  
  // Search
  search_placeholder: "Поиск больницы, услуги или типа лечения...",
  search_button: "Поиск",
  
  // Services Menu
  services_title: "Наши услуги",
  services_subtitle: "Широкий спектр медицинских услуг и полная поддержка",
  
  service_dental: "Стоматология",
  service_dental_desc: "Импланты, ламинаты, отбеливание, коронки",
  
  service_plastic: "Пластическая хирургия",
  service_plastic_desc: "Подтяжка лица, операции на глазах, маммопластика, липосакция",
  
  service_antiaging: "Анти-эйджинг",
  service_antiaging_desc: "Стволовые клетки, NAD инъекции",
  
  service_orthopedic: "Ортопедия",
  service_orthopedic_desc: "Лечение коленного сустава, стволовые клетки/коллаген",
  
  service_eye: "Офтальмология",
  service_eye_desc: "LASIK, LASEK, Smile Lasik операции",
  
  service_skin: "Уход за кожей",
  service_skin_desc: "Пети, лифтинг, скин бустер, уход за кожей",
  
  service_cancer: "Лечение рака",
  service_cancer_desc: "Операции по удалению рака, химиотерапия",
  
  service_spine: "Позвоночник",
  service_spine_desc: "Операции на межпозвоночных дисках",
  
  service_proctology: "Проктология",
  service_proctology_desc: "Геморрой, операции при анальных трещинах",
  
  service_gynecology: "Гинекология",
  service_gynecology_desc: "Гинекологические осмотры, центр лечения бесплодия",
  
  service_checkup: "Комплексное обследование",
  service_checkup_desc: "Полная программа проверки здоровья",

  service_hair_transplant: "Пересадка волос",
  service_hair_transplant_desc: "Пересадка волос методами FUE и DHI",

  service_varicose: "Лечение варикоза",
  service_varicose_desc: "Расширение вен ног, лазерное и склеротерапевтическое лечение",
  
  // News & Events
  news_title: "Новости и события",
  news_subtitle: "Последние новости медицинского туризма и специальные предложения",
  read_more: "Подробнее",
  
  // Chat Consultation
  chat_title: "Онлайн консультация",
  chat_subtitle: "Поддержка 24/7 с профессиональными медицинскими переводчиками",
  chat_cta: "Начать чат",
  chat_description: "Наши специалисты готовы помочь вам. Задайте свои вопросы и получите бесплатную консультацию.",
  
  // Recommendations
  recommendations_title: "Рекомендовано для вас",
  recommendations_subtitle: "Персонализированные услуги, соответствующие вашим потребностям",

  rec_knee_stem_title: "Стволовые клетки колена",
  rec_knee_stem_desc: "Современная клеточная терапия для коленного сустава",
  rec_knee_stem_duration: "2-3 часа",
  rec_upper_eyelid_title: "Блефаропластика",
  rec_upper_eyelid_desc: "Операция на верхнем веке, коррекция разреза глаз",
  rec_upper_eyelid_duration: "1-2 часа",
  rec_rhinoplasty_title: "Ринопластика",
  rec_rhinoplasty_desc: "Коррекция формы носа, ринопластика",
  rec_rhinoplasty_duration: "2-3 часа",
  rec_skin_care_title: "Уход за кожей",
  rec_skin_care_desc: "Лифтинг, ботокс, филлер, лазерная терапия",
  rec_skin_care_duration: "30-60 минут",
  rec_teeth_whitening_title: "Отбеливание зубов",
  rec_teeth_whitening_desc: "Профессиональное отбеливание зубов, эстетическая стоматология",
  rec_teeth_whitening_duration: "1-2 часа",
  rec_health_checkup_title: "Комплексное обследование",
  rec_health_checkup_desc: "Полное медицинское обследование и диагностика",
  rec_health_checkup_duration: "4-6 часов",
  rec_breast_surgery_title: "Маммопластика",
  rec_breast_surgery_desc: "Увеличение груди и коррекция формы",
  rec_breast_surgery_duration: "2-3 часа",
  rec_facelift_title: "Подтяжка лица",
  rec_facelift_desc: "Подтяжка кожи лица, омолаживающая операция",
  rec_facelift_duration: "3-4 часа",
  
  // Partner Hospitals
  hospitals_title: "Больницы-партнёры",
  hospitals_subtitle: "Сотрудничество с лучшими медицинскими учреждениями Южной Кореи",
  view_details: "Подробнее",
  view_all_hospitals: "Все больницы",
  
  // Why Choose Us
  why_choose_title: "Почему MediVoyage?",
  why_choose_subtitle: "Полный опыт медицинского туризма",
  
  feature_interpreter: "Профессиональные медицинские переводчики",
  feature_interpreter_desc: "Услуги профессиональных переводчиков во время общения с врачами",
  
  feature_visa: "Визовая поддержка",
  feature_visa_desc: "Полная помощь в получении медицинской туристической визы",
  
  feature_accommodation: "Проживание и туры",
  feature_accommodation_desc: "Отели рядом с больницей и туристические программы",
  
  feature_consultation: "Онлайн консультация",
  feature_consultation_desc: "Онлайн консультация перед приездом в Корею",
  
  feature_support: "Поддержка 24/7",
  feature_support_desc: "Постоянная поддержка во время вашего путешествия",
  
  feature_package: "Полный пакет",
  feature_package_desc: "Всё от консультации до лечения и путешествий",
  
  // Footer
  footer_about: "О MediVoyage",
  footer_about_text: "Мы организуем онлайн-консультации с врачами, записываем к подходящим специалистам в проверенные клиники, обеспечиваем услуги профессионального переводчика, а также организуем поездки по туристическим достопримечательностям Кореи для пациентов, приезжающих на лечение.",
  footer_quick_links: "Быстрые ссылки",
  footer_services: "Услуги",
  footer_contact_us: "Свяжитесь с нами",
  footer_address: "Адрес",
  footer_email_label: "Эл. почта",
  footer_phone_label: "Телефон",
  footer_follow_us: "Следите за нами",
  footer_rights: "© 2025 MediVoyage. Все права защищены.",
  
  // Common
  learn_more: "Узнать больше",
  contact_us: "Связаться с нами",
  book_now: "Забронировать",
  get_started: "Начать",
  view_all: "Посмотреть все",

  // Contact Section
  contact_badge: "Контакты",
  contact_title: "Свяжитесь с нами",
  contact_subtitle: "Есть вопросы? Наши специалисты готовы помочь вам.",
  contact_office_uz: "Узбекистан",
  contact_office_kr: "Корея",
  contact_email_label: "Электронная почта",
  contact_social_title: "Следите за нами в соцсетях",
  contact_form_title: "Отправить сообщение",
  contact_service_label: "Тип услуги",
  contact_service_placeholder: "Выберите услугу",
  contact_service_consultation: "Медицинская консультация",
  contact_service_visa: "Визовая поддержка",
  contact_service_accommodation: "Проживание и отель",
  contact_service_interpreter: "Услуги медицинского переводчика",
  contact_service_tour: "Туры и экскурсии",
  contact_service_package: "Полный медицинский пакет",
  contact_specialty_label: "Желаемое направление лечения",
  contact_specialty_placeholder: "Выберите направление",
  contact_specialty_dental: "Стоматология",
  contact_specialty_plastic: "Пластическая хирургия",
  contact_specialty_eye: "Офтальмология (LASIK/LASEK)",
  contact_specialty_skin: "Уход за кожей и эстетика",
  contact_specialty_orthopedic: "Ортопедия и суставы",
  contact_specialty_spine: "Позвоночник",
  contact_specialty_cancer: "Лечение рака",
  contact_specialty_gynecology: "Гинекология и бесплодие",
  contact_specialty_antiaging: "Анти-эйджинг и стволовые клетки",
  contact_specialty_checkup: "Комплексное медицинское обследование",
  contact_specialty_proctology: "Проктология",
  contact_specialty_other: "Другое",
  contact_visit_date_label: "Желаемая дата визита",
  contact_visit_date_hint: "Укажите даже приблизительную дату",
  contact_message_label: "Сообщение",
  contact_submit: "Отправить",
  contact_sending: "Отправка...",
  contact_success_title: "Сообщение отправлено!",
  contact_success_msg: "Мы свяжемся с вами в ближайшее время.",
  contact_send_another: "Отправить ещё",
  contact_error_msg: "Произошла ошибка. Пожалуйста, попробуйте снова.",

  // Hospital Detail
  hospital_detail_specialties: "Специализации",
  hospital_detail_about: "О больнице",
  hospital_detail_location: "Расположение",
  hospital_detail_contact_info: "Контактная информация",
  hospital_detail_website: "Веб-сайт",
  hospital_detail_phone: "Телефон",
  hospital_detail_address: "Адрес",
  hospital_detail_consultation: "Консультация через MediVoyage",
  hospital_detail_consultation_desc: "Получите бесплатную консультацию для лечения в этой больнице",
  hospital_detail_book_consultation: "Записаться на консультацию",
  back_to_list: "Вернуться к списку",

  // Consultation Popup
  popup_consultation_title: "Записаться на консультацию",
  popup_treatment: "Направление лечения",
  popup_name: "Имя",
  popup_name_placeholder: "Введите ваше имя",
  popup_phone: "Телефон",
  popup_phone_placeholder: "+7 XXX XXX XX XX",
  popup_email: "Электронная почта",
  popup_email_placeholder: "email@example.com",
  popup_message: "Дополнительная информация",
  popup_message_placeholder: "Опишите ваш вопрос или пожелание...",
  popup_submit: "Отправить заявку",
  popup_submitting: "Отправка...",
  popup_success_title: "Заявка отправлена!",
  popup_success_msg: "Наши специалисты свяжутся с вами в течение 24 часов.",
  popup_close: "Закрыть",
  popup_error_msg: "Произошла ошибка. Попробуйте снова.",

  // Privacy Consent
  privacy_consent: "Я согласен(а) на обработку персональных данных",
  privacy_consent_required: "Необходимо согласие на обработку персональных данных",
  privacy_policy: "Политика конфиденциальности",
};

export default common;
